module.exports = __webpack_public_path__ + "media/jdc_loop.c886e82d.mp4";